export default "__VITE_ASSET__BzYBS0L___"